import styled from 'styled-components'

export const OutlineContainer = styled.div`
width: 100%;
border-radius: 4px;
padding: 1rem;
display: flex;
flex-direction: column;
box-shadow: var(--SombraBackground);
border: 1px solid var(--${props => props.theme});
`

export const BoxContainer = styled.div`
width: 100%;
border-radius: 4px;
padding: 1rem;
display: flex;
color: white;
flex-direction: column;
background: var(--${props => props.theme});
`

export const ContainerFiltro = styled.div`
display: flex;
align-items: center;
background-color: white;
border-radius: 8px;
width: 100%;
`
